"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledOutputLevel = exports.OutputIndicator = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject, _templateObject2;
var StyledOutputLevel = exports.StyledOutputLevel = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  gap: 5px;\n  height: 16px;\n"])));
var OutputIndicator = exports.OutputIndicator = _styledComponents["default"].span(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  background: ", ";\n  border-radius: 2px;\n  width: 10%;\n  height: 5px;\n"])), function (_ref) {
  var isActive = _ref.isActive,
    color = _ref.color;
  return isActive ? color : '#DFE3EC';
});